/** @format */

import { useEffect, useCallback } from "react";
import { Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Dashboard from "../Table/dashboard/Dashboard";
import User from "../Table/user/User";
import Setting from "../Table/setting/Setting";

import UserProfile from "../Table/user/UserProfile";
import Seller from "../Table/seller/Seller";
import AdminProfile from "../Table/admin/AdminProfile";
import SellerRequest from "../Table/sellerRequest/SellerRequest";
import SellerProfile from "../Table/seller/SellerProfile";
import AddSeller from "../Table/seller/AddSeller";
import Product from "../Table/Product/Product";
import ProductDetail from "../Table/Product/ProductDetail";
import Category from "../Table/category/Category";
// import Order from "../Table/Order/Order";
import Order from "../Table/Order/Order";
import OrderDetail from "../Table/Order/OrderDetail";
import PromoCode from "../Table/PromoCode/PromoCode";
import FaQ from "../Table/FAQ/Faq";
import Attribute from "../Table/Attribute/Attribute";
import Redeem from "../Table/redeem/Redeem";
import CategoryWiseSubCategory from "../Table/subCategory/CategoryWiseSubCategory";
import PendingProduct from "../Table/Product/PendingProduct";
import ApprovedProduct from "../Table/Product/ApprovedProduct";
import RejectedProduct from "../Table/Product/RejectedProduct";
import ProductRequestView from "../Table/Product/ProductRequestView";
import AddProduct from "../Table/Product/AddProduct";
import PaymentSetting from "../Table/setting/paymentSetting";
import LogisticsSetting from "../Table/setting/logisticsSetting";
import PaidShippingRates from "../Table/paidShipping/PaidShippingRates";
import KosLocations from "../Table/kosLocation/KosLocations";
import UpdateRequest from "../Table/Product/UpdateRequest";
import UpdateProducutApproved from "../Table/Product/UpdateProducutApproved";
import UpdateProductRejected from "../Table/Product/UpdateProductRejected";
import SellerOrderDetail from "../Table/seller/Profile/SellerOrderDetail";
import LiveSeller from "../Table/liveSeller/LiveSeller";
import LiveSellerProduct from "../Table/liveSeller/LiveSellerProduct";
import AdminWallet from "../Table/admin/AdminWallet";
// import EditSellerR from "../Table/sellerRequest/EditSellerR";
import EditSellerRequest from "../Table/sellerRequest/EditSellerRequest";
import FakeSeller from "../Table/fakeSeller/FakeSeller";
import Reels from "../Table/reels/Reels";
import FakeReels from "../Table/fakeReels/FakeReels";
import ReelsInfo from "../Table/reels/ReelsInfo";
// import ReportedReels from "../Table/reels/ReportedReels";
import FakeSellerDialogue from "../Table/fakeSeller/FakeSellerDialogue";
import FakeProduct from "../Table/FakeProduct/FakeProduct";
import { useSelector } from "react-redux";
import BankSetting from "../Table/bank/BankSetting";
import CurrencySetting from "../Table/currencySetting/currencySetting";
import AdminEarning from "../Table/admin/AdminEarning";
import AdminWithdrawal from "../Table/AdminWithdrawal/AdminWithdrawal";
import AdminRefund from "../Table/AdminRefund/AdminRefund";
import ReportReason from "../Table/reportReason/ReportReason";
import Condition from "../Table/Condition/Condition";
import ChatAbuse from "../Table/ChatAbuse/ChatAbuse";
import { Video } from "lucide-react";
import VideoReport from "../Table/videoReport/VideoReport";
import AdminUsers from "../Table/admin/AdminUsers";

export const token = sessionStorage.getItem("token");

const Admin = ({ isAuthenticated }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const { isAuth } = useSelector((state) => state.admin);

	useEffect(() => {
		if (location.pathname == "/" || location.pathname == "/admin" || location.pathname == "" || location.pathname == "/admin/") {
			navigate("/admin/dashboard");
		}
	}, []);

	// Sidebar submenu and nav toggle logic is now handled via
	// React state in the Sidebar component and CSS classes.
	// The navToggle click is dispatched as a custom event from Navbar.
	useEffect(() => {
		const handleNavToggle = () => {
			document.querySelector(".mainNavbar")?.classList.toggle("mobNav");
			document.querySelector(".mainNavbar")?.classList.toggle("webNav");
			document.querySelector(".sideBar")?.classList.toggle("mobSidebar");
			document.querySelector(".sideBar")?.classList.toggle("webSidebar");
			document.querySelector(".mainAdmin")?.classList.toggle("mobAdmin");
		};
		document.addEventListener("navToggle", handleNavToggle);
		return () => document.removeEventListener("navToggle", handleNavToggle);
	}, []);

	return (
		<>
			<div className='mainContainer d-flex w-100'>
				<div className='containerLeft'>
					<Sidebar />
				</div>
				<div className='containerRight w-100'>
					<Navbar />
					<div className='mainAdmin'>
						<Routes>
							{/* dashboard */}
							<Route path='/dashboard' element={<Dashboard />} />

							{/* user */}

							<Route path='/user' element={<User />} />
							<Route path='/UserProfile' element={<UserProfile />} />
							<Route path='/sellerRequestEdit' element={<EditSellerRequest />} />

							{/* seller */}
							<Route path='/seller' element={<Seller />} />
							<Route path='/fakeSeller' element={<FakeSeller />} />
							<Route path='/addFakeSeller' element={<FakeSellerDialogue />} />
							<Route path='/liveSeller' element={<LiveSeller />} />
							<Route path='/liveSellerProduct' element={<LiveSellerProduct />} />
							<Route path='/sellerProfile' element={<SellerProfile />} />
							<Route path='/addSeller' element={<AddSeller />} />
							<Route path='/sellerOrderDetail' element={<SellerOrderDetail />} />
							{/* seller Request */}
							<Route path='/sellerRequest' element={<SellerRequest />} />

							{/* category  && subCategory */}
							<Route path='/category' element={<Category />} />
							<Route path='/category/subCategory' element={<CategoryWiseSubCategory />} />

							{/* attributes */}
							<Route path='/attribute' element={<Attribute />} />

							{/* Product */}
							<Route path='/product' element={<Product />} />
							<Route path='/addProduct' element={<AddProduct />} />
							<Route path='/fake/addProduct' element={<AddProduct />} />

							<Route path='/productDetail' element={<ProductDetail />} />
							<Route path='/fake/productDetail' element={<ProductDetail />} />

							{/* Fake Product */}
							<Route path='/fakeProduct' element={<FakeProduct />} />

							{/* video Report */}
							<Route path='/videoreport' element={<VideoReport />} />

							{/* create Product Request by App */}
							<Route path='/pendingProduct' element={<PendingProduct />} />
							<Route path='/approvedProduct' element={<ApprovedProduct />} />
							<Route path='/rejectedProduct' element={<RejectedProduct />} />
							<Route path='/productRequestView' element={<ProductRequestView />} />

							{/* update Product Request by App */}

							<Route path='/pendingUpdateRequest' element={<UpdateRequest />} />
							<Route path='/approvedUpdateRequest' element={<UpdateProducutApproved />} />
							<Route path='/rejectedUpdateRequest' element={<UpdateProductRejected />} />

							{/* order */}
							<Route path='/order' element={<Order />} />
							<Route path='/order/orderDetail' element={<OrderDetail />} />

							{/* promoCode */}
							<Route path='/promoCode' element={<PromoCode />} />

							{/* FaQ */}
							<Route path='/faq' element={<FaQ />} />

							{/* admin Profile */}
							<Route path='/profilePage' element={<AdminProfile />} />
							{/* <Route path="/wallet" element={<AdminWallet />} /> */}
							<Route path='/adminwithdrawal' element={<AdminWithdrawal />} />
							<Route path='/refund' element={<AdminRefund />} />
							<Route path='/wallet' element={<AdminEarning />} />

							{/* setting */}
							<Route path='/setting' element={<Setting />} />
							<Route path='/currencySetting' element={<CurrencySetting />} />
							<Route path='/paymentSetting' element={<PaymentSetting />} />
							<Route path='/logisticsSetting' element={<LogisticsSetting />} />
							<Route path='/paidShippingRates' element={<PaidShippingRates />} />
							<Route path='/kosLocations' element={<KosLocations />} />
							<Route path='/bankSetting' element={<BankSetting />} />
							<Route path='/reportreason' element={<ReportReason />} />
							<Route path='/conditions' element={<Condition />} />
							<Route path='/chatAbuse' element={<ChatAbuse />} />

							{/* admin users */}
							<Route path='/adminUsers' element={<AdminUsers />} />

							{/* reels */}

							<Route path='/reels' element={<Reels />} />
							{/* <Route path="/reportedReels" element={<ReportedReels />} /> */}

							<Route path='/real/reels/details' element={<ReelsInfo />} />

							<Route path='/fake/reels/details' element={<ReelsInfo />} />

							{/* fake reels */}

							<Route path='/fakeReels' element={<FakeReels />} />
						</Routes>
					</div>
				</div>
			</div>
		</>
	);
};

export default Admin;
